import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import image1 from './images/hot_coffee.png'
import image2 from './images/brew.png'
import image3 from './images/coldc.png'
import image4 from './images/hotc2.png'
import image5 from './images/milkshake.png'
import image6 from './images/mocktail.png'
import Card from 'react-bootstrap/Card';
import banner from './images/productback.jpg'
import './product.css'
import NavigationBar from './nav';
import NewNav from './canvas';
import Aos from 'aos';
import "aos/dist/aos.css";
import { useEffect } from 'react';

function Product() {

  useEffect(()=>{
    Aos.init({duration:"1000"})
  })

  const products = [
    { id: 1, name: "Coffee", image: image1,link:"coffee" },
    { id: 2, name: "Cold Brew", image: image2,link:"rock" },
    { id: 3, name: "Cold Coffee & Frappe", image: image3 ,link:"frap"},
    // { id: 4, name: "Hot Chocolate", image: image4,link:"hotc" },
    { id: 5, name: "Hot Chocolate", image: image4,link:"hotc" },
    { id: 6, name: "Mocktails & Ice Tea's", image: image6,link:"mock" },
  ]


  return (
    <>
      <Container fluid>
      <Row>
      <NavigationBar/>
      <NewNav/>
        <Col id='productTop'>
        
        <Row>
          <Col id='productHeading'>
          <p data-aos="zoom-in">Time To Drink Coffee</p>
          </Col>
        </Row>
        </Col>
      </Row>
    </Container>
    
    <br></br>
     <Container className="py-3">
      {/* First Row - 4 Cards */}
      <Row>
          <Col md={12} style={{ justifyContent:"center",overflow:"hidden" }}>
            <Row>
              <div className="row justify-content-center">
              {products.slice(0,3).map((p) => (
                <Col data-aos="flip-left" xs={4} md={3} key={products.id} style={{ marginTop: "20px",textAlign:"center",overflow:"hidden"}}>
                  
                  <Card style={{border:"none"}}>
                    <a href={p.link} style={{textDecoration:"none",color:"black"}}>
                    <Card.Img id='productimg' 
                      src={p.image} />
                    <Card.Body>
                      <Card.Title id='productTitle'>
                        <span >
                          {p.name}
                        </span>
                      </Card.Title>
                    </Card.Body>
                    </a>
                  </Card>
                </Col>
              ))}
              </div>
            </Row>
            <Row>
              <div className="row justify-content-center">
              {products.slice(3).map((p) => (
                <Col data-aos="flip-left" xs={4} md={3} key={products.id} style={{ marginTop: "20px",textAlign:"center",overflow:"hidden"}}>
                  <Card style={{border:"none"}}>
                    <a href={p.link} style={{textDecoration:"none",color:"black"}}>
                    <Card.Img id='productimg' 
                      src={p.image} />
                    <Card.Body>
                      <Card.Title id='productTitle'>
                        <span >
                          {p.name}
                        </span>
                      </Card.Title>
                    </Card.Body>
                    </a>
                  </Card>
                </Col>
              ))}
              </div>
            </Row>
          </Col>
        </Row>

    </Container>
    
    </>
  )
}

export default Product